import { extendTheme } from "@chakra-ui/react";
import "@fontsource/inter/400.css";

const theme = extendTheme({
    fonts: {
        heading: `'Inter', sans-serif`,
        body: `'Inter', sans-serif`,
    },
});

export default theme;
